/**
 * Debug-mode helper for content debugging.
 *
 * When enabled, in-game screens show the card's IndexedDB id under the
 * text — host can screenshot and the dev/agent knows EXACTLY which card
 * to rename / rewrite / delete.
 *
 * Stored in localStorage so it survives reloads. Toggle from Settings.
 */
const KEY = "pp.debug";

export function isDebugEnabled(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(KEY) === "1";
}

export function setDebugEnabled(on: boolean): void {
  if (typeof localStorage === "undefined") return;
  if (on) localStorage.setItem(KEY, "1");
  else localStorage.removeItem(KEY);
  // Notify any listeners (rare — most components read on mount).
  try {
    window.dispatchEvent(new StorageEvent("storage", { key: KEY }));
  } catch {
    /* ignore in non-browser */
  }
}
